// extracted by mini-css-extract-plugin
module.exports = {"button":"NavButtons_button__E5HEb","buttonRight":"NavButtons_buttonRight__3rCad","buttonLeft":"NavButtons_buttonLeft__dYIlz"};